/**
 * 采购差额调账的修改页面 表单配置处理
 * @author zjs
 * @time 2017-10-11
 */
export default {
    data () {
        return {
            formConfig: [{
                name: "开单日期",
                type: "LyDatePicker",
                field: "work_time",
                json: {
                    type: 'date',
                    disabled: true
                },
                default: ""
            }, {
                name: "单据类型",
                type: "ElInput",
                field: "type",
                json: {
                    disabled: true
                },
                default: "采购差额调账单"
            },{
                name: "登记单号",
                type: "ElInput",
                field: "transaction_no_display",
                json: {
                    disabled: true
                },
                default: ""
            },{
                name: "供应商编码",
                type: "LyAutoSearch",
                field: "provider",
                width: '220px',
                json: {
                    width: '251px',
                    api: 'api/provider',
                    prop: 'provider_code',
                    fields: [{
                        label: '供应商编码',
                        prop: 'provider_code',
                        width: 100
                    }, {
                        label: '供应商名称',
                        prop: 'provider_name',
                        width: 150
                    }]
                },
                default: {}
            }, {
                name: "供应商名称",
                type: "LyAutoSearch",
                field: "provider",
                width: '220px',
                json: {
                    width: '251px',
                    api: 'api/provider',
                    prop: 'provider_name',
                    fields: [{
                        label: '供应商编码',
                        prop: 'provider_code',
                        width: 100
                    }, {
                        label: '供应商名称',
                        prop: 'provider_name',
                        width: 150
                    }]
                },
                default: {}
            }, {
                name: "起始日期",
                type: "LyDatePicker",
                field: "date_start",
                json: {
                    type: 'date',
                    isToday: false
                },
                default: ""
            }, {
                name: "截止日期",
                type: "LyDatePicker",
                field: "date_end",
                json: {
                    type: 'date',
                    isToday: false
                },
                default: ""
            }, {
                name: "开单部门",
                type: "ElInput",
                json: {
                    disabled: true
                },
                field: "department_name"
            }, {
                name: "制单人",
                type: "ElInput",
                json: {
                    disabled: true
                },
                field: "zhidan_name"
            }]
        }
    },
    created () {
        if (this.userInfo.is_fencang === 1) {
            this.formConfig.push({
                name: "调账仓库",
                type: "LySelect",
                field: "warehouse_id",
                json: { 
                    all: false,
                    api: 'api/warehouse'
                },
                default: ""
            })
        }
        this.formConfig.push({
            name: "摘要",
            type: "ElInput",
            field: "zhaiyao",
            width: '1005px',
            json: {
                span: 24
            },
            default: ""
        })
    }
}